import { BBCODE } from 'src/constants/regex';

export const pluralize = (singular, plural, count) => {
  return (count > 1 || count === 0) ? plural.replace('%1$s', count) : singular.replace('%1$s', count);
};

// ;; Blacklisted characters for slug creation
// ;; http://www.blooberry.com/indexdot/html/topics/urlencoding.htm
const SLASHES = /\//g;
const CONTROL_CHARS = /[\b\t\n\f\r]/g;
const RESERVED_CHARS = /[\$&\+,\/:;=\?@]/g;
const UNSAFE_CHARS = /[\"<>#%\{\}\|\^~\[\]`]/g;
const EXTRA_CHARS = /[\(\)!\-]/g;

// This makes the name safe to use for a slug. it is implemantation should be synchronized with
// https://github.com/HealthUnlocked/Aurora-API/blob/develop/Aurora.API/Utils/Common.cs#L194-L237
// for SEO sake Ported code from planck
// Note: copied from BG
export const createSlug = (str) => {
  if (!str) return '';

  return unescape(str)
    .toLowerCase()
    .replace(SLASHES, ' ')
    .replace(CONTROL_CHARS, ' ')
    .replace(RESERVED_CHARS, ' ')
    .replace(UNSAFE_CHARS, ' ')
    .replace(EXTRA_CHARS, ' ')
    .trim()
    .replace(/[\s]+/g, '-')
    .replace("'", '');
};

// note: copied from BG
export const numberFormat = (number, dec, dsep, tsep) => {
  if (isNaN(number) || number == null) {
    return '';
  }

  number = number.toFixed(Math.floor(dec));
  tsep = typeof tsep == 'string' ? tsep : ',';

  var parts = number.split('.'), fnums = parts[0],
    decimals = parts[1] ? (dsep || '.') + parts[1] : '';

  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
};

export const stripBBTags = (str) => {
  return str.replace(BBCODE, '');
};

export const arrayToSentence = (arr) =>
  arr.reduce((prev, curr, i) => {
    return prev + curr + ((i === arr.length - 2) ? ' and ' : ', ');
  }, '')
  .slice(0, -2);

export const stringToKey = str => str.trim().substring(0, 8).replace(/\s/gi, '-').toLowerCase();
